export default "__VITE_ASSET__P7gOCyeE__"